export default __webpack_public_path__ + "static/media/layer-satellite.cef8a13d.png";